import { calendar_sync } from '../../../../lib/apiList'
import axios from '../../../../lib/axios'
import { GetCalendarParams } from '../types'
import { UpdateCalendarRequest } from './type'

const getLocBasedUsers = async (locid: string) => {
    const response = await axios.get(`${calendar_sync.LOCBASEDUSERS}${locid}`)
    return response
}

const getLocations = (): Promise<any> => {
    return axios.post(calendar_sync.GETLOCATIONS, {})
}

const createCalendar = async (data: any) => {
    const response = await axios.post(calendar_sync.CREATE_CALENDAR, data)
    return response
}
const getCalendar = async ({
    currentPage,
    recordsPerPage,
}: GetCalendarParams): Promise<any> => {
    const data = {
        pageSize: recordsPerPage ? recordsPerPage : 10,
        pageNumber: currentPage ? currentPage : 1,
        orderBy: ['CreatedOn desc'],
    }
    const response = await axios.post(calendar_sync.GET_ALL_CALENDAR, data)
    return response
}

const delAssignUser = async (calendarId: string, userIds: string[]) => {
    const response = await axios.delete(
        `${calendar_sync.DELETE_ASSIGNED_USER}${calendarId}`,
        {
            data: userIds,
        }
    )
    return response
}

const getAssignedUsers = async (id: string) => {
    const response = await axios.get(calendar_sync.GET_ASSIGNED_USER + id)
    return response
}
const deleteCalendarEvent = async (id: string) => {
    const response = await axios.delete(calendar_sync.DELETE_CALENDAR + id)
    return response
}

const getSpecificCalendar = async (id: string): Promise<any> => {
    const url = `${calendar_sync.GET_CALENDAR}/${id}`
    const response = await axios.get(url)
    return response
}

const getCalendarAssignedUsers = async (id: string): Promise<any> => {
    const url = `${calendar_sync.GET_CALENDAR_ASSIGNED_USERS}/${id}`
    const response = await axios.get(url)
    return response
}

const updateCalendar = async (
    id: string,
    data: UpdateCalendarRequest
): Promise<any> => {
    const url = `${calendar_sync.UPDATE_CALENDAR}/${id}`
    const response = await axios.put(url, data)
    return response
}

export {
    getLocBasedUsers,
    getLocations,
    createCalendar,
    getCalendar,
    delAssignUser,
    getAssignedUsers,
    deleteCalendarEvent,
    getSpecificCalendar,
    getCalendarAssignedUsers,
    updateCalendar,
}
